import { Component, Input } from '@angular/core';
import { LabelService } from '../../../shared/services/label.service';
import { Walk } from '../../../shared/models/walk.model';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-walk-tile',
  templateUrl: 'walk.tile.component.html',
  imports: [NgIf],
})
export class WalkTileComponent {
  // Pass data from parent to child with input binding
  @Input() item: Walk = new Walk();

  LINK_LABEL: string;

  /**
   *
   * @param labelService
   */
  constructor(private labelService: LabelService) {
    this.LINK_LABEL = labelService.getLabel('linkLabel');
  }
}
